import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class PaymentMethodDto extends BaseEntityDto {
  name: string;

  requiresAccountingReconciliation: boolean;

  canBeIncludedInExpenseSheet: boolean;

  isDefaultForPurchaseOrders: boolean;
}
